export const MedicationAlarm = {
  PageName: {
    MedicationAlarmList: '服薬アラーム一覧',
    MedicationAlarm: 'アラーム設定',
    MedicationAlarmSettingTime: '服薬アラーム 時間設定',
    SelectMedicine: '服薬するお薬',
  },
  Label: {
    Overview: '「アラーム設定」機能説明',
    ExplanationStart:
      'お薬・サプリ単位でアラームを設定できます。下記アラーム設定後、実際の服薬チェックは「',
    ExplanationMiddle: '薬を飲む',
    ExplanationEnd: '」からチェック可能です。',
    StartDay: '服薬開始',
    UserName: '患者さまのお名前',
    AlarmName: 'アラーム名',
    TakingMedicine: '服薬するお薬',
    AddMedcine: 'お薬を追加する',
    Term: '服薬期間の設定',
    Start: '服薬開始日',
    Days: '服薬日数',
    Indefinite: '無期限',
    ManyDays: '日分',
    Interval: '服薬間隔',
    EveryDay: '毎日',
    Space: '日おき',
    Day: '日',
    Week: '曜日指定',
    AlarmSetting: {
      Title: 'アラーム時間の設定',
      Explain: '設定を変更する',
    },
    Monday: '月曜日',
    Tuesday: '火曜日',
    Wednesday: '水曜日',
    Thursday: '木曜日',
    Friday: '金曜日',
    Saturday: '土曜日',
    Sunday: '日曜日',
    PharmacyMemo: '薬剤師からの連絡・注意事項',
    UserMemo: 'メモ',
  },
  Button: {
    Add: '追加する',
    AddAlarm: 'アラームを追加する',
    AddMedicationAlarm: '服薬アラームを追加する',
    DeleteAlarm: 'アラームを削除しますか？',
    Update: '更新する',
    Delete: '削除する',
    UpdateCustomAlarm: '登録',
  },
  Dialog: {
    Label: {
      Complete: {
        Create: 'アラームを登録しました',
        Update: 'アラームを更新しました',
        Delete: 'アラームを削除しました',
      },
      Comfirm: 'アラームを削除しますか？',
      Limit: {
        CustomAlarm: 'アラームの登録数は8個までです',
        Medicine: 'お薬の登録数は40個までです',
      },
    },
  },
};
